"use strict";
export const formatTelephone = (telephoneNumber) => {
  return telephoneNumber.replace(/[^(\d|+)]/g, "");
};
